export const API_ENDPOINTS = {
  catalogsL1: "/catalogs",
  catalogsL2: "/catalogs2",
  catalogsL3: "/catalogs3",
  chemicals: "/chemicals",
  singleChemical: "/singleChemical",
  chemicalsFilter: "/chemicalsFilter",
  getUtility: "/getUtility",
  getBanner: "/banner",
  getCompanyMission: "/companymission",
  getSeviceheading: "/seviceheading",
  allServices: "/service/all",
  getVision: "/vision",
  allClients: "/client/all",
  getTestimonial: "/testimonial/all",
  getArticles: "/artical/all",
  getSettings: "/settings",
  getAboutBanner: "/about-us",
  getAboutUsCard: "/about-us-cards",
  getTimeline: "/timeline/all",
  contactUs: "/contact-form",
  employmentBanner: "/employment-banner",
  employmentResponsibilities: "/employmentAt",
  personnelBanner: "/teambanner",
  personnelCharacterized: "/p-characteristics",
  getTeamMember: "/team/all",
  operatingPhilosophy: "/operating-philosophy",
  operatingPhilosophyDiagram: "/operatingphilosophygraph/all",
  getCustomChemicalSynthesis: "/customchemicalsynthesis/all",
  singleCustomChemicalSynthesis: "/customchemicalsynthesis/one",
  expertiseIncludes: "/expertiseincludes",
  caseStudyTabs: "/casestudymain/all",
  singleCaseStudyTabs: "/casestudymain/one",
  caseStudyGraphContent: "/case_study_graph_center",
  getCaseStudyDiagramData: "/case_study_graph/all",
  testimonialPageHeading: "/testimonial2head",
  getAllTestimonial2: "/testimonial2/all",
  getTherapeuticsBanner: "/service-banner",
  supportTherapeutics: "/service-second",
  allStepsTherapeutics: "/servicethird/all",
  serviceFeaturedImage: "/servicethirdfeatured",
  getAdcLinker: "/service-fourth",
  getTherapeuticsBottom: "/service-fifth",
  carbohydrateBanner: "/complex-carbohydrate-banner",
  allCarbohydrateTimeline: "/complexcarboTimeline/all",
  allCarbohydrateDiagram: "/complex-timeline-diagram/all",
  researchDevelopmentBanner: "/researchdevelopmentbanner",
  researchDevelopmentSort: "/researchdevelopmentsecond",
  getResearchTab: "/research-and-development/all",
  resume: "/resume",
  chemistryExpertiseBanner: "/chemistryexpertisebanner",
  getAllChemistryTabs: "/chemistryexpertise/all",
  resourceHeading: "/resourceshead",
  resourceUsefulGuides: "/resourceusefulguides",
  allResourcesTabs: "/resourcestabs/all",
  whitepaperBanner: "/whitepaperbanner",
  allWhitepapers: "/whitepaperblog/all",
  singleWhitepaper: "/whitepaperblog/one",
  addToCart: "/addToCart",
  getCart: "/getCart",
  deleteCart: "/deleteCart",
  updateCart: "/updateCart",
  checkout: "/checkout",
  onPayment: "/onPaypal",
  paymentSuccess: "/payment-success",
  paymentCancel: "/payment-cancel",
  conferenceBanner: "/conferencebanner",
  conferenceCards: "/conferences/all",
  partnerBanner: "/partnersbanner",
  getAllPartnerCards: "/partnercasestudycard/all",
  partnersbottom: "/partnersbottom",
  partnerFifthCard: "/partners_section_three",
  allPartnersLogo: "/partnerslogos/all",
  capabilitiesOverview: "/overviewbanner",
  analyticalInstrumentation: "/analytical-instrumentation",
  accreditations: "/accreditations",
  labEquipmentBanner: "/lab-equipment-banner",
  allLabEquipments: "/lab-equipment/all",
  checkCoupon: "/coupon-apply",
  removeCoupon: "/coupon-delete",
  chemicalsFilterExact: "/chemicalsFilterExact",
  processMidSection: "/ProcessResearchDevelopmentoneAbout",
  processBanner: "/ProcessResearchDevelopmentBanner",
  getProcessTab: "/ProcessResearchDevelopment/all",
  processResearchDiagram: "/ProcessResearchDiagram",
  smallMoleculeBanner: "/smdd-bannerBanner",
  smallHTS: "/smdd-hts",
  smallSBDD: "/smdd-sbdd",
  smallSAR: "/smdd-sar",
  scaffHolding: "/scaffold-hopping",
  smallLeadDevelopment: "/smdd-lead_development",
  getAllSmallMoleculeTabs: "/smdd-tabs/all",
  isotopeBanner: "/isotope-banner",
  isotopeAssessment: "/isotope-assessment",
  getIsotopeTable: "/isotope-table/all",
  isotopeDetails: "/isotope-details",
  isotopeButtons: "/isotope-buttons",
  projectManagementBanner: "/project_management-banner",
  getAllProjectManagementList: "/project-management/all",
  projectManagementBottomDesc: "/project-management-footer",
  othersBanner: "/others-banner",
  allOthersList: "/others/all",
  overviewBanner: "/overview",
  allOverviewTab: "/overview-main/all",
  allAnalyticalInstrument: "/analytical-instrumentation-main/all",
  allSynthesis: "/synthesis-main/all",
  researchCollaborationBanner: "/research-collaboration-banner",
  researchCollaborationMidSection: "/research-collaboration-mid-section",
  allResearchCollaborationAcademia: "/research-collaboration-academia/all",
  allResearchCollaborationCompany: "/research-collaboration-company/all",
  researchCollaborationDiagram: "/research-collaboration-diagram",
  footerLinks: "/menu-titles",
  getTestimonialClient: "/logo-listing",
  headerSearch: "/search",
};
